<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <button class="btn btn-success ml-auto" @click="update()">{{ 'update' | t }}</button>
    </div>
    <div>
      <mail-builders-form-general :template_type="mail_builder_template_type"></mail-builders-form-general>
      <mail-builders-form-locales :template_type="mail_builder_template_type"></mail-builders-form-locales>
      <mail-builders-form-attributes :template_type="mail_builder_template_type"></mail-builders-form-attributes>
      <div class="container my-5">
        <div class="row">
          <div class="col d-flex">
            <button class="btn btn-success ml-auto" @click="update()">{{ 'update' | t }}</button>
          </div>
        </div>
      </div>
    </div>
  </with-actions>
</template>
<script>
// @ts-check
import Api from '@/store/jsonapi';
import Alerts, { handle } from '@/utils/alerts';

export default {
  props: {
    mail_builder_template_type: {
      type: Object,
      required: true
    }
  },
  methods: {
    update: handle(async function () {
      // Removes unnused locale_types. Takes a copy to keep interface intact for possible later changes
      const template_type_copy = JSON.parse(JSON.stringify(this.mail_builder_template_type));
      const valid_active_locales = ['en'];
      template_type_copy.attribute_types.forEach((attribute_type) => {
        attribute_type.locale_types.forEach((locale_type, index) => {
          if (!locale_type.key && !locale_type.value && !locale_type.description) {
            delete attribute_type.locale_types[index];
            return;
          }

          if (locale_type.value && !valid_active_locales.includes(locale_type.locale)) {
            valid_active_locales.push(locale_type.locale);
          }
        });
      });

      // Remove unnused locales from active_locales (picked in selected, but done nothing to)
      template_type_copy.active_locales = valid_active_locales;

      await Api.update('mail_builder_template_types', template_type_copy);
      Alerts.success({
        title: this.$t('success'),
        detail: this.$t('mail_builder_template_saved')
      });
    })
  }
};
</script>
